import Collapse from 'bootstrap/js/dist/collapse';

(function ($) {

    document.addEventListener('DOMContentLoaded', function() {
        PostSlider();
        Megamenu();
        ScrollTriggers();
        Testimonials();
        OurWork();
        MobileNav();
        Sliders();
        FancyBox();
        People();
        QuickGuide();
    });

    function QuickGuide() {
        $('[data-js-quick-guide] input[name="delivery"]').on('change', function() {
            const $email = $('[data-js-quick-guide] input[type="email"]');
            switch ($(this).val()) {
                case "email":
                    $email.attr('required','true');
                    break;
                default:
                    $email.removeAttr('required');
            }
        });

        $('[data-js-quick-guide]').submit(function(e) {
            e.preventDefault();
            const $form = $(this);
            const $submit = $form.find('[type="submit"]');
            $submit.attr('disabled', true);
            const data = $form.serialize()+'&action='+$form.attr('action');
            $.ajax({
                type: $form.find('_METHOD').val() || $form.attr('method'),
                url: theme_params.ajaxurl,
                data: data,
                success: function (res) {
                    if (res.redirect  !== undefined) {
                        window.location.replace(res.redirect);
                    } else if (res.url  !== undefined) {
                        window.open(res.url,"_blank");
                    }
                    if (res.message  !== undefined) {
                        $submit.after($('<div class="mb-4">'+res.message+'</div>'));
                    }
                },
                error: function (xhr) {
                    $submit.removeAttr('disabled');
                    // Other error
                    if (xhr.status == 500) {
                        let message = "Error";
                        if (typeof xhr.responseJSON.message !== "undefined") {
                            message = xhr.responseJSON.message;
                        }
                        alert(message);
                    }
                    // Validation error
                    if (xhr.status === 422) {
                        alert('The following errors were found:\n\n' + xhr.responseJSON.errors.join('\n'));
                    }
                }
            });
        });
    }

    function People() {
        $('[data-js-people-shuffle]').click(function () {
            const container = $('.facetwp-template');
            const nodes = container.children();
            for (var i = 1; i < nodes.length; i++) {
                container.append(nodes.eq(Math.floor(Math.random() * nodes.length)));
            }
        });
    }

    function Sliders() {
        $('[data-js-more-work]').each(function() {
            var $container = $(this);
            var $slider = $container.find('[data-slider]');
            var $prev = $container.find('[data-prev]');
            var $next = $container.find('[data-next]');
            $slider.slick({
                arrows: false,
                centerMode: true,
                slidesToShow: 5,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $next.click(function(e) {
                e.preventDefault();
                $slider.slick('slickNext');
            });
            $prev.click(function(e) {
                e.preventDefault();
                $slider.slick('slickPrev');
            });
        })

        $('[data-js-image-slider]').each(function() {
           var $slider = $(this);
            $slider.on('init', function(event, slick){
                $(this).append('<div class="image_slider__count badge fw-medium rounded-pill position-absolute bottom-0 start-50 translate-middle-x mb-3 py-2"><span data-current>1</span>/<span data-total>'+slick.slideCount+'</span></div>');
            });
            $slider.slick({
                arrows: true,
                prevArrow:"<button type='button' class='slick-prev'><svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\"><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2.5\" d=\"M25 13H1M13 25 1 13 13 1\"/></svg></button>",
                nextArrow:"<button type='button' class='slick-next'><svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\"><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2.5\" d=\"M1 13h24M13 1l12 12-12 12\"/></svg></button>",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
            $slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
                $slider.find('[data-current]').html(currentSlide+1);
            });
        });

    }

    function MobileNav() {
        $('#nav-toggle').on('click', function () {
            $('body').toggleClass('nav-is-active');
            $(this).toggleClass('is-active');
            $(this).attr('aria-expanded', $(this).hasClass('is-active'));
        });
        $('#menu-header .menu-item-has-children>a').each(function() {
            const $sectionLink = $(this).clone();
            const $backBtn = $('<a href="#" class="sub-menu__back-btn">Back</a>');
            $backBtn.on('click', function(e) {
               e.preventDefault();
               $(this).closest('.active').removeClass('active');
            });
            const $subMenu = $(this).next();
            $subMenu.prepend($sectionLink.wrap('<li></li>'));
            $subMenu.prepend($backBtn);
        });
        $('#menu-header .menu-item-has-children>a').on('click', function(e) {
            if ($('body').hasClass('nav-is-active')) {
                e.preventDefault();
                $(this).next().addClass('active');
            }
        });
    }


    function Testimonials() {
        $("section.testimonials .testimonial-row").each(function() {
            $(this).slick({
                arrows: true,
                dots: false,
                prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-left\" viewBox=\"0 0 16 16\">\n" +
                    "  <path fill-rule=\"evenodd\" d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\"/>\n" +
                    "</svg></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-right\" viewBox=\"0 0 16 16\">\n" +
                    "  <path fill-rule=\"evenodd\" d=\"M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z\"/>\n" +
                    "</svg></button>",
                slidesToShow: 2,
                slidesToScroll: 2,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            })
        });
    }

    function OurWork() {
        $("[data-js-our-work]").each(function() {
            const $container = $(this);
            const $buttons = $container.find('[data-target]');
            const $panels = $container.find('[data-category]');
            $buttons.on("click", function(e) {
                e.preventDefault();
                const $button = $(this);
                $button.addClass('active');
                $button.siblings().removeClass('active');
                const category = $(this).data('target');
                if (category.length) {
                    $panels.each(function() {
                        const $panel = $(this);
                        if ($panel.data('category') == category) {
                            $panel.parent().show();
                        } else {
                            $panel.parent().hide();
                        }
                    });
                } else {
                    $panels.show();
                }
            });
        });
    }

    function PostSlider() {
        $(".post-slider .slider").each(function() {
            $(this).slick({
                // centerMode: true,
                slidesToShow: 2,
                infinite: false,
                slidesToScroll: 2,
                arrows: true,
                dots: false,
                prevArrow:"<button type='button' class='slick-prev'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" fill=\"currentColor\" class=\"bi bi-chevron-left\" viewBox=\"0 0 16 16\">\n" +
                    "  <path fill-rule=\"evenodd\" d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\"/>\n" +
                    "</svg></button>",
                nextArrow:"<button type='button' class='slick-next'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" fill=\"currentColor\" class=\"bi bi-chevron-right\" viewBox=\"0 0 16 16\">\n" +
                    "  <path fill-rule=\"evenodd\" d=\"M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z\"/>\n" +
                    "</svg></button>",
                responsive: [
                    {
                        breakpoint: 600,
                        settings: "unslick"
                    }
                ]
            });
        });
    }

    function Megamenu() {

        let parent = document.querySelector("header.masthead");
        let wrapper = parent.querySelector(".megamenu-wrapper");
        let mayHide = true;
        let touch = ( 'ontouchstart' in window ) ||
            ( navigator.maxTouchPoints > 0 ) ||
            ( navigator.msMaxTouchPoints > 0 );

        const menuItems = document.querySelectorAll("#menu-header .nav-link[data-megamenu]");
        if (menuItems.length === 0) {
            return;
        }

        menuItems.forEach(function (item) {

            item.addEventListener('click', function (e) {
                if (touch) {
                    e.preventDefault();
                    item.nextSibling.nextSibling.classList.add('active');
                }
            });

            item.addEventListener('mouseenter', function () {
                if (!touch) {
                    showMegamenu(this.dataset.megamenu);
                }
            });
            item.addEventListener('mouseleave', function () {
                if (!touch) {
                    hideMegamenu();
                }
            });
        });

        function showMegamenu(identifier) {

            const megamenu = document.querySelector('.megamenus [data-identifier="' + identifier + '"]');
            if (!megamenu) {
                hideMegamenu();
                return;
            }

            // Set up the container, if it doesn't exist
            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.classList.add("megamenu-wrapper");
                parent.appendChild(wrapper);
            }
            wrapper.innerHTML = megamenu.innerHTML;

            // Position the megamenu off screen
            wrapper.style.top = wrapper.offsetHeight * -1 + "px";

            // Show the megamenu
            setTimeout(() => {
                mayHide = false;
                parent.classList.add("megamenu-visible");
            }, 50);

            wrapper.addEventListener('mouseenter', function () {
                mayHide = false;
            });

            wrapper.addEventListener('mouseleave', function () {
                hideMegamenu();
            });

        }

        function hideMegamenu() {
            mayHide = true;
            setTimeout(() => {
                if (mayHide) {
                    parent.classList.remove("megamenu-visible");
                }
            }, 400);
        }

    }

    function ScrollTriggers() {
        document.querySelectorAll('[data-js-sroll-trigger="lozenge"]').forEach((container)=> {
            const target = container.querySelector('[data-target]');
            gsap.to(target,{
                scrollTrigger: {
                    trigger: container,
                    start: "30px",
                    end: "100px",
                    toggleActions: "play complete play reverse",
                    scrub: true
                },
                width: '100%',
            });
        });

        document.querySelectorAll('[data-js-sroll-trigger="parallax"]').forEach((target)=> {
            const value = target.dataset.value;
            gsap.to(target,{
                scrollTrigger: {
                    toggleActions: "restart pause reverse pause",
                    scrub: 2,
                },
                translateY: value,
            });
        });
    }

    function FancyBox() {
        $('.fancybox').fancybox();
    }

})(window.jQuery)
